import type { PlanType } from '#dn-types/billing.ts';
import { useAuth } from '#global/context/auth/useAuth.tsx';

type PlanFeatures = {
  prioritySupport: boolean;
};

type FeatureFlagFeatures = {
  hostsLimit: number;
  routesLimit: number;
};

type Features = PlanFeatures & FeatureFlagFeatures;

// These are features which are not included in a feature-flag, but depend on the plan type
const PLAN_MAP = {
  free: {
    prioritySupport: false,
  },
  pro: {
    prioritySupport: true,
  },
} satisfies Record<PlanType, PlanFeatures>;

export function useCapabilities() {
  const { featureFlags, plan } = useAuth().user?.organization ?? {};

  if (!featureFlags || !plan) return { isLoading: true, capabilities: null };

  return {
    isLoading: false,
    capabilities: {
      ...PLAN_MAP[plan],
      hostsLimit: featureFlags.HOST_LIMIT,
      routesLimit: featureFlags.ROUTES_LIMIT,
    } satisfies Features,
  };
}
